import React, { useState, useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { useLocation } from 'react-router-dom';
import { IconContext } from 'react-icons/lib';
import { RiMenu4Fill } from 'react-icons/ri';

import {
  Nav,
  NavbarContainer,
  NavLogo,
  LogoImage,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLink,
  NavButton
} from './navbar.styles';

import { CallToActionRoute } from 'components/common/CallToActionRoute';
import { dynamicLinks } from './navbar.data';

const Navbar = ({ toggle }) => {
  const { pathname } = useLocation();
  const [scrollNav, setScrollNav] = useState(false);

  const handleChangeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  // react-scroll
  const ScrollToTop = () => {
    scroll.scrollToTop();
  };

  useEffect(() => {
    window.addEventListener('scroll', handleChangeNav);
    return () => {
      window.removeEventListener('scroll', handleChangeNav);
    };
  }, []);

  return (
    <>
      <IconContext.Provider value={{ color: '#e4e4e4' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to="/" onClick={ScrollToTop}>
              <LogoImage />
              Crypto Wallet
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <RiMenu4Fill />
            </MobileIcon>
            <NavMenu>
              {pathname === '/' ? (
                dynamicLinks.map((item) => (
                  <NavItem key={item.id}>
                    <NavLink
                      to={item.path}
                      exact="true"
                      smooth={true}
                      spy={true}
                      duration={600}
                      delay={100}
                      offset={-80}
                    >
                      {item.url}
                    </NavLink>
                  </NavItem>
                ))
              ) : (
                <NavItem></NavItem>
              )}
            </NavMenu>
            {pathname === '/' ? (
              <NavButton>
                <CallToActionRoute to="/signin">
                  Sign In<span className="btn-cta--gradient"></span>
                </CallToActionRoute>
              </NavButton>
            ) : (
              <NavButton>
                <CallToActionRoute to="/" onClick={ScrollToTop}>
                  Home<span className="btn-cta--gradient"></span>
                </CallToActionRoute>
              </NavButton>
            )}
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
